import { render } from "./Member_invoiceRecord.vue?vue&type=template&id=76ff9a48"
import script from "./Member_invoiceRecord.vue?vue&type=script&lang=js"
export * from "./Member_invoiceRecord.vue?vue&type=script&lang=js"
script.render = render

export default script